import {
  CheckinsOption,
  InboxOption,
  ScheduledOption,
  SentOption,
} from "contexts/OutreachContacts";
import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

export enum Page {
  RECOMMENDATIONS = "recommendations",
  BRANDS = "brands",
  HOME = "home",
  INBOX = "inbox",
  TRACKING = "tracking",
  CAMPAIGNS = "campaigns",
  LOCAL = "local",
  VA = "virtual-assistant",
  AUTOPILOT = "autopilot",
  INSTAGRAM = "instagram",
  TEMPLATES = "templates",
  SETTINGS = "settings",
  PROFILE = "profile",
  BENTO_GUIDE = "bento",
  SAVED_BRANDS = "saved-brands",
}

export const PageMenu: Map = {
  [Page.RECOMMENDATIONS]: {
    label: "Recommendations",
    icon: "fa-thin fa-star",
    routes: routes.recommendations,
  },
  [Page.HOME]: {
    label: "Home",
    icon: "fa-thin fa-home",
    routes: routes.home,
  },
  [Page.BRANDS]: {
    label: "Brands",
    icon: "fa-thin fa-search",
    routes: routes.brands,
  },
  [Page.INBOX]: {
    label: "Inbox",
    icon: "fa-thin fa-envelope",
    children: [ScheduledOption, SentOption, InboxOption, CheckinsOption],
    routes: routes.inbox,
  },
  [Page.TRACKING]: {
    label: "Tracking",
    icon: "fa-thin fa-square-kanban",
    routes: routes.tracking,
  },
  [Page.CAMPAIGNS]: {
    label: "Campaigns",
    icon: "fa-thin fa-chart-simple-horizontal",
    routes: routes.campaignView,
  },
  [Page.LOCAL]: {
    label: "Pitch Local",
    icon: "fa-thin fa-location-dot",
    routes: routes.pitchLocal,
  },
  [Page.VA]: {
    label: "AI Virtual Assistant",
    icon: "fa-thin fa-bolt",
    routes: routes.virtualAssistant,
  },
  [Page.AUTOPILOT]: {
    label: "Autopilot",
    icon: "fa-thin fa-bolt",
    routes: routes.autopilot,
  },
  [Page.TEMPLATES]: {
    label: "Templates",
    icon: "fa-thin fa-pen",
    routes: routes.templates,
  },
  [Page.SETTINGS]: {
    label: "Settings",
    icon: "fa-regular fa-gear",
    routes: routes.settings,
  },
  [Page.PROFILE]: {
    label: "Profile",
    icon: "fa-thin fa-user",
    routes: routes.profile,
  },
  [Page.BENTO_GUIDE]: {
    label: "How to Use Bento",
    icon: "fa-regular fa-wrench",
  },
};
